import React from 'react';
import { getOperationalMetricMeta } from '../../../constants/operationalMetricCatalog';
import { formatMoneyMetricValue } from './metricFormat';
import { KpiCard, KpiLabel, KpiValue } from './styles';

/**
 * @param {{ metricKey: string, data?: { value?: number, currency?: string }, loading?: boolean, compact?: boolean }} props
 */
export default function MoneyMetricCard({ metricKey, data = {}, loading = false, compact = false }) {
    const { label } = getOperationalMetricMeta(metricKey);
    const display = loading ? '—' : formatMoneyMetricValue(data);

    if (compact) {
        return (
            <KpiCard aria-label={label}>
                <KpiLabel>{label}</KpiLabel>
                <KpiValue>{display}</KpiValue>
            </KpiCard>
        );
    }

    return <KpiValue>{display}</KpiValue>;
}
